import _styled2 from "styled-components";
import _styled from "styled-components";
import {Config} from "../../../../../__snowpack__/link/packages/config/dist/config.esm.js";
import {useWhiteLabelDm} from "../../../../../__snowpack__/link/packages/old-dm/dist/dm.esm.js";
import {useTranslation} from "../../../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import {useLogger} from "../../../../../__snowpack__/link/packages/logger/dist/logger.esm.js";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {cmpClassName, execFn} from "../../../../common/generic-react.functions.js";
import Icon from "../../../../components/atoms/icon/icon.component.js";
import Label from "../../../../components/atoms/label/label.component.js";
import Modal from "../../../../components/atoms/modal/modal.component.js";
import DataTableActions from "../../../../components/molecules/data-table-actions/data-table-actions.component.js";
import DeleteDialog from "../../../../components/molecules/delete-dialog/delete-dialog.component.js";
import ListSection from "../../../../components/organisms/list-section/list-section.component.js";
import {withReduxAndStyle} from "../../../../hoc/bridge.hoc.js";
import {useReduxFiltersWhiteLabel} from "../../../../redux/filters/filters.hooks.js";
import WhiteLabelDetailPage from "../detail/white-label-detail.page.js";
function WhiteLabelListPage({
  jwt,
  options: tableOptions,
  onDelete,
  onDeleted,
  onEdit,
  onChange,
  onCompleteEdit,
  onError,
  reactSubmissionCallbackError
}) {
  const [selectedId, setSelectedId] = useState(0);
  const {
    t,
    tHtml
  } = useTranslation();
  const {
    error
  } = useLogger("whitelabel-list");
  const [filterBy, , resetFilters] = useReduxFiltersWhiteLabel();
  const {
    deleteClientInstance,
    getClientInstanceList
  } = useWhiteLabelDm(jwt);
  const [items, setItems] = useState([]);
  const [options, setOptions] = useState({
    filterBy
  });
  const modalEdit = useRef(null);
  const modalDelete = useRef(null);
  const paginationItems = useMemo(() => Config.dmEnvironment.defaultLimitResults, []);
  const [viewMode, setViewMode] = useState(false);
  useEffect(() => {
    setOptions((oldOptions) => ({
      ...oldOptions,
      filterBy
    }));
  }, [filterBy]);
  useEffect(() => {
    return () => {
      resetFilters();
    };
  }, [resetFilters]);
  const headers = useMemo(() => [{
    text: t("whiteLabel.table.name"),
    value: "name",
    align: "start",
    sortable: true
  }, {
    text: t("whiteLabel.table.actions"),
    value: "actions",
    align: "end",
    sortable: false
  }], [t]);
  const preDeleteClientInstance = useCallback((id) => {
    setSelectedId(id);
    modalDelete.current?.show();
  }, []);
  const closeModal = useCallback(() => {
    setViewMode(false);
    modalEdit.current?.hide();
  }, []);
  const closeModalDelete = useCallback(() => {
    modalDelete.current?.hide();
  }, []);
  const openModal = useCallback((id = 0) => {
    setSelectedId(id);
    modalEdit.current?.show();
  }, []);
  const confirmDelete = useCallback(() => {
    deleteClientInstance(selectedId).then(() => {
      execFn(onDeleted, selectedId);
    }).catch((e) => {
      error(e);
      execFn(onError, e);
    });
    setItems([...items.filter((it) => it.id !== selectedId)]);
    closeModalDelete();
  }, [closeModalDelete, deleteClientInstance, error, items, onDeleted, onError, selectedId]);
  const editWhiteLabel = useCallback((id, name = "", isViewMode = false) => {
    setSelectedId(id);
    if (name === "Leonardo247") {
      setViewMode(isViewMode);
    } else {
      setViewMode(false);
    }
    if (onEdit) {
      onEdit(id);
    } else {
      openModal(id);
    }
  }, [onEdit, openModal]);
  const generateItem = useCallback(({
    name,
    id
  }) => {
    let actions;
    if (name === "Leonardo247") {
      actions = /* @__PURE__ */ React.createElement(DataTableActions.EditRemove, {
        onView: () => editWhiteLabel(id, name, true),
        viewMode: true
      });
    } else {
      actions = /* @__PURE__ */ React.createElement(DataTableActions.EditRemove, {
        onEdit: () => editWhiteLabel(id, name),
        onDelete: () => onDelete ? execFn(onDelete, id) : preDeleteClientInstance(id),
        viewMode: false
      });
    }
    return {
      name,
      id,
      actions
    };
  }, [editWhiteLabel, onDelete, preDeleteClientInstance]);
  const submittedEdit = useCallback((info) => {
    if (selectedId) {
      setItems([...items.map((it) => it.id === selectedId ? generateItem(info) : it)]);
    } else {
      setItems([...items, generateItem(info)]);
    }
    closeModal();
  }, [closeModal, generateItem, items, selectedId]);
  const generateItems = useCallback((results, count) => {
    const parsedResults = results.map(generateItem);
    setOptions((oldOptions) => ({
      ...oldOptions,
      itemsTotal: count,
      sortBy: ["name"],
      itemsPerPage: paginationItems
    }));
    return parsedResults;
  }, [generateItem, paginationItems]);
  const getPage = useCallback((page = 1) => {
    const params = {
      search: tableOptions?.filterBy?.name?.toString(),
      limit: paginationItems,
      page
    };
    delete tableOptions?.filterBy?.name;
    getClientInstanceList(params).then(({
      results,
      count
    }) => {
      const parsedResults = generateItems(results, count);
      const instanceWithId = parsedResults.map((instance) => ({
        ...instance,
        name: `${instance.name} (id: ${instance.id})`
      }));
      setItems(instanceWithId);
    }).catch((e) => {
      error(e);
      execFn(onError, e);
    });
  }, [error, generateItems, getClientInstanceList, onError, paginationItems, tableOptions?.filterBy?.name]);
  const destroyEdit = useCallback(() => {
    execFn(onCompleteEdit, selectedId);
  }, [onCompleteEdit, selectedId]);
  const changeEdit = useCallback((info) => {
    execFn(onChange, info);
  }, [onChange]);
  const paginateEvent = useCallback((page) => {
    getPage(page);
  }, [getPage]);
  useEffect(() => {
    paginateEvent();
  }, [paginateEvent]);
  return /* @__PURE__ */ React.createElement("div", {
    className: cmpClassName("white-label-list")
  }, /* @__PURE__ */ React.createElement(ListSection, {
    what: "whiteLabel",
    headers,
    items,
    options: {
      ...options,
      ...tableOptions
    },
    onPaginate: paginateEvent
  }), /* @__PURE__ */ React.createElement(Modal, {
    ref: modalEdit,
    width: "820px",
    dismiss: true,
    persistent: true,
    modalClassName: "white-label-detail-modal"
  }, /* @__PURE__ */ React.createElement(WhiteLabelDetailPage, {
    jwt,
    id: selectedId,
    onSubmit: submittedEdit,
    onCancel: closeModal,
    onDestroy: destroyEdit,
    onChange: changeEdit,
    onView: viewMode,
    reactSubmissionCallbackError
  })), /* @__PURE__ */ React.createElement(DeleteDialog, {
    ref: modalDelete,
    onDelete: confirmDelete,
    header: t("whiteLabel.delete.title").toUpperCase(),
    onCancel: closeModalDelete
  }, /* @__PURE__ */ React.createElement(_StyledLabel, {
    tag: "div",
    color: "var(--warningColor)"
  }, /* @__PURE__ */ React.createElement(_StyledIcon, {
    name: "exclamation-circle"
  }), tHtml("whiteLabel.delete.text"))));
}
export default /* @__PURE__ */ React.memo(withReduxAndStyle(WhiteLabelListPage));
var _StyledLabel = _styled(Label).withConfig({
  displayName: "white-label-listpage___StyledLabel",
  componentId: "sc-oc9nmy-0"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%"
});
var _StyledIcon = _styled(Icon).withConfig({
  displayName: "white-label-listpage___StyledIcon",
  componentId: "sc-oc9nmy-1"
})({
  marginRight: "1rem"
});
